import React, { useEffect, useState } from "react";
import { Button, Skeleton, Grid, TextField, Typography, IconButton } from "@mui/material";
import InfoIcon from '@mui/icons-material/Info';
import { ForecastReviewGrid } from "../../Components/ForecastReviewGrid";
import ProductMultiSelection from "../../Components/ProductMultiSelection";
import { useForecastReviewContext } from "../../Contexts/forecastReviewContext";
import { useDistributorsContext } from "../../Contexts/distributorsContext";
import { CustomerType } from "../../Enums/CustomerType";
import { useProductsContext } from "../../Contexts/productsContext";
import DistributorMultiselection from "../../Components/DistributorMultiSelection";
import PropTypes from 'prop-types';
import { SKU_LOCAL_STORAGE_KEY, DISTRIBUTOR_LOCAL_STORAGE_KEY } from "../../Utilities/constants.ts";
import InfoDialog from './dialogs/InfoDialog';
import ErrorDialog from './dialogs/ErrorDialog';

export const ForecastReview = ({
  editableWeeksStartIndex,
  editableWeeksEndIndex,
  startWeek,
  endWeek
}) => {
  const { selectedDistributors, setSelectedDistributors } = useDistributorsContext();
  const { selectedProducts, setSelectedProducts } = useProductsContext();
  const { isReady: areForecastReviewItemsReady, forecastReviewItems, getFormattedOriginalForecastReviewItems, setForecastReviewItems, get } = useForecastReviewContext();
  const [exporting, setExporting] = useState(false);
  const [file, setFile] = useState(null);
  const [infoDialogOpen, setInfoDialogOpen] = useState(false);
  const [errorDialogOpen, setErrorDialogOpen] = useState(false);
  const [errorData, setErrorData] = useState(null);

  useEffect(() => {
    const storedSku = localStorage.getItem(SKU_LOCAL_STORAGE_KEY)
    if (storedSku) {
      setSelectedProducts(JSON.parse(storedSku));
    }

    const storedDistributor = localStorage.getItem(DISTRIBUTOR_LOCAL_STORAGE_KEY)
    if (storedDistributor && storedDistributor !== "undefined") {
      setSelectedDistributors(JSON.parse(storedDistributor));
      get();
    }
  }, []);

  useEffect(() => {
    if (selectedDistributors) {
      get();
    }
    localStorage.setItem(DISTRIBUTOR_LOCAL_STORAGE_KEY, JSON.stringify(selectedDistributors));
  }, [selectedDistributors, areForecastReviewItemsReady, setSelectedDistributors]);

  const exportForecast = () => {
    setExporting(true);

    let distributors = "";
    selectedDistributors.forEach(distributor => distributors += `distributorIds=${distributor.distributorId}&`);

    let products = "";
    selectedProducts.forEach(product => products += `productSKUs=${product.sku}&`);

    window.open(`api/Distributor/Forecasts/csvFile?${distributors}${products}`);

    setExporting(false);
  };

  const handleUpload = async () => {
    if (!file) {
      alert("Please select a file first.");
      return;
    }

    const formData = new FormData();
    formData.append("file", file);

    try {
      const response = await fetch("api/Distributor/Forecasts/import", {
        method: "POST",
        body: formData,
      });

      if (response.ok) {
        const result = await response.json();
        alert(result.message || "File uploaded successfully!");
        setFile(null);
        get();
      } else {
        const errorData = await response.json();
        setErrorData({
          message: errorData.message || "Error uploading file",
          errors: errorData.errors || []
        });
        setErrorDialogOpen(true);
      }
    } catch (error) {
      alert("Error uploading file.");
      console.error("Upload Error:", error);
    }
  };

  const handleFileChange = (event) => {
    const selectedFile = event.target.files[0];
    if (selectedFile && (selectedFile.type !== "text/csv" && !selectedFile.name.endsWith(".csv"))) {
      alert("Invalid file type. Please select a CSV file.");
      setFile(null);
    } else {
      setFile(selectedFile);
    }
  };

  useEffect(() => {
    if (forecastReviewItems?.length === 0) {
      const selectedSKUs = selectedProducts?.map(selectedProduct => selectedProduct.sku);
      setForecastReviewItems(getFormattedOriginalForecastReviewItems().filter(forecastReviewItem => selectedSKUs.length > 0 ? selectedSKUs.includes(forecastReviewItem.product.sku) : true));
      localStorage.setItem(SKU_LOCAL_STORAGE_KEY, JSON.stringify(selectedProducts));
    }
  }, [selectedProducts, areForecastReviewItemsReady, setSelectedProducts]);

  return (
    <React.Fragment>
      <Grid container columnSpacing={2} paddingLeft={2} paddingTop={2} justifyContent="end" alignItems="center">
        <Grid item xs={4}>
          <DistributorMultiselection
            customerType={CustomerType.VMI}
            filterByCanOrderBeer={true}
            onClose={() => get()}
          />
        </Grid>
        <Grid item xs={4}>
          <ProductMultiSelection />
        </Grid>
        <Grid item xs={4}>
          <Grid container columnSpacing={2} paddingRight={10} justifyContent="end" alignItems="center">
            <Grid item xs={6}>
              {/* <Grid container direction="row" spacing={1} alignItems="center" justifyContent="flex-end">
                <Grid item>
                  <TextField
                    type="file"
                    onChange={handleFileChange}
                    style={{ display: "none" }}
                    id="forecast-file-input"
                    accept=".csv"
                  />
                  <label htmlFor="forecast-file-input">
                    {!file ?
                      <Button variant="contained" component="span" size="small">
                        Upload Forecasts
                      </Button> :
                      <Button
                        variant="contained"
                        color="primary"
                        onClick={handleUpload}
                        disabled={!file}
                        size="small"
                      >
                        Upload
                      </Button>}
                  </label>
                </Grid>
                <Grid item>
                  <IconButton
                    onClick={() => setInfoDialogOpen(true)}
                    size="small"
                    sx={{ color: 'primary.main' }}
                  >
                    <InfoIcon />
                  </IconButton>
                </Grid>
                {file && (
                  <Grid item>
                    <Typography variant="body2" sx={{ maxWidth: 150, overflow: 'hidden', textOverflow: 'ellipsis' }}>
                      {file.name}
                    </Typography>
                  </Grid>
                )}
              </Grid> */}
            </Grid>
            <Grid item xs={3}>
              <Button
                variant="outlined"
                disabled={forecastReviewItems.length === 0}
                onClick={() => {
                  setForecastReviewItems([]);
                  get();
                }}
                style={{ marginLeft: "80%" }}
              >
                Reset
              </Button>
            </Grid>
            <Grid item xs={3}>
              <Button
                variant="outlined"
                disabled={forecastReviewItems.length === 0 && !exporting}
                onClick={exportForecast}
                style={{ marginLeft: "80%" }}
              >
                Export
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </Grid>

      {!selectedDistributors || !areForecastReviewItemsReady ? (
        selectedDistributors && !areForecastReviewItemsReady ? (
          <Skeleton variant="rectangular" height={400} />
        ) : (
          <center style={{ padding: 25 }}>
            <h4>Please select a distributor to review their forecast</h4>
          </center>
        )
      ) : forecastReviewItems.length === 0 ? (
        <center style={{ padding: 25 }}>
          <h4>There is no forecast data for the selected filter</h4>
          <h5>
            If you believe this is an error, please contact your business
            partner or the helpdesk at
            <a href="mailto: customerservice@bostonbeer.com"> customerservice@bostonbeer.com</a>
          </h5>
        </center>
      ) : (
        <ForecastReviewGrid editableWeeksStartIndex={editableWeeksStartIndex} editableWeeksEndIndex={editableWeeksEndIndex} startWeek={startWeek} endWeek={endWeek} isHistorical={false} />
      )}
      <InfoDialog open={infoDialogOpen} onClose={() => setInfoDialogOpen(false)} />
      <ErrorDialog open={errorDialogOpen} onClose={() => setErrorDialogOpen(false)} errorData={errorData} />
    </React.Fragment >
  );
};

ForecastReview.propTypes = {
  editableWeeksStartIndex: PropTypes.number,
  editableWeeksEndIndex: PropTypes.number,
  startWeek: PropTypes.number,
  endWeek: PropTypes.number
}